module.exports = __webpack_public_path__ + "images/1ffacb28ca93bcf9c4676835b1916537-home-button-hover.png";